import React from 'react';
import { CloseButton, Dialog, Portal, Text } from '@chakra-ui/react';

function AuthDialog({ open, onClose, title, description, children }) {
  return (
    <Dialog.Root
      open={open}
      onOpenChange={(details) => {
        if (!details.open) onClose();
      }}
      placement="center"
    >
      <Portal>
        <Dialog.Backdrop
          bg="blackAlpha.500"
          css={{ backdropFilter: 'blur(4px)' }}
        />
        <Dialog.Positioner p={4}>
          <Dialog.Content
            maxW="420px"
            w="full"
            borderRadius="xl"
            overflow="hidden"
            bg={{ base: 'rgba(248, 250, 252, 0.98)', _dark: 'rgba(15, 23, 42, 0.96)' }}
            borderWidth="1px"
            borderColor="surface.border"
            boxShadow="0 18px 40px rgba(15, 23, 42, 0.35)"
            css={{ backdropFilter: 'blur(26px)', boxSizing: 'border-box' }}
          >
            <Dialog.Header pt={5} px={5} pb={0} position="relative">
              <Dialog.Title fontSize="lg" fontWeight="semibold" color="page.fg">
                {title}
              </Dialog.Title>
              <Dialog.CloseTrigger asChild position="absolute" top={3} right={3}>
                <CloseButton size="sm" />
              </Dialog.CloseTrigger>
            </Dialog.Header>
            <Dialog.Body px={5} py={4} className="auth-dialog-body">
              {description ? (
                <Text fontSize="sm" color={{ base: 'gray.600', _dark: 'gray.400' }} mb={3}>
                  {description}
                </Text>
              ) : null}
              {children}
            </Dialog.Body>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
}

export default AuthDialog;
